import React, { useMemo, useState, useEffect } from 'react';

import PropTypes from "prop-types";
import MaterialReactTable from 'material-react-table';
import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";

const { size } = typography;
const { primary, secondary, text, divider, tableRow, transparent } = colors;



const LicenseHistory_table = (props) => {
    
    const columns = useMemo(
        () => {
            const baseColumns = [
                {
                    header: 'Modified At',
                    accessorKey: 'history_modified_at',
                    id: 'history_modified_at',
                    accessorFn: (row) => {
                        let dts = new Date(row.history_modified_at).toLocaleString();
                        if (dts !== 'Invalid') {
                            return dts;
                        } else {
                            return "-";
                        }
                    }
                },
                {
                    header: 'History Action',
                    accessorKey: 'history_action',
                    id: 'history_action',
                    enableColumnFilter: false,
                },
                {
                    header: 'Probes',
                    accessorKey: 'num_probes',
                    id: 'num_probes',
                    enableColumnFilter: false,
                },
                {
                    header: 'Views',
                    accessorKey: 'num_views',
                    id: 'num_views',
                    enableColumnFilter: false,
                },
                {
                    header: 'Updated By',
                    accessorKey: 'updated_by',
                    id: 'updated_by',
                    enableColumnFilter: false,
                },
                {
                    header: 'Effective Date',
                    accessorKey: 'lic_start',
                    id: 'lic_start',
                    accessorFn: (row) => {
                        let dts = new Date(row.lic_start);
                        if (dts !== 'Invalid Date') {
                            return String(row.lic_start).substring(0, 10);
                        } else {
                            return "-";
                        }
                    },
                    enableColumnFilter: false,
                },

                {
                    header: 'Expiration Date',
                    accessorKey: 'lic_end',
                    id: 'lic_end',
                    accessorFn: (row) => {
                        let dts = new Date(row.lic_end);
                        if (dts !== 'Invalid Date') {
                            return String(row.lic_end).substring(0, 10);
                        } else {
                            return "-";
                        }
                    },
                    enableColumnFilter: false,
                },
                {
                    header: 'Notes',
                    accessorKey: 'lic_ref_value',
                    id: 'lic_ref_value',
                    enableColumnFilter: false,
                },
            ];

       
        const shouldShowVmsColumn = props.selectedCustomer && props.selectedCustomer.product_type === 'mavric-monitoring-onprem';

        if (shouldShowVmsColumn) {
            return [
                ...baseColumns.slice(0, 4),
                {
                    header: 'VMs',
                    accessorKey: 'num_vms',
                    id:'num_vms',
                    enableColumnFilter: false,
                    // Cell: ({ row }) => 
                    //     row.original.product_type === 'mavric-monitoring-onprem'
                    //         ? row.original.num_vms
                    //         : '-',
                },
                ...baseColumns.slice(4) 
            ];
        }

        return baseColumns;
        }, []
    )

    const [data, setData] = useState(props.data);


    return (
        <MaterialReactTable
            columns={columns}
            data={data}
            defaultColumn={{ size: 125 }}
            muiTableToolbarAlertBannerProps={{ sx: { display: 'none' } }}
            muiTablePaperProps={{ sx: { boxShadow: 'none', backgroundColor: primary.main } }}
            muiTableBodyRowProps={({ row }) => ({
                hover: true,
                sx: {
                    color: text.main,
                    align: 'center',
                    '&:nth-of-type(odd)': {
                        backgroundColor: tableRow.dark,
                        border: 0,
                    },
                    '&:nth-of-type(even)': {
                        background: tableRow.light,
                    },
                    // hide last border
                    '&:last-child td, &:last-child th': {
                        border: 0,
                    },
                    '&:hover td': {
                        background: tableRow.hover,
                    },
                },
            })}
            //muiTableBodyProps={{sx:{boxShadow: 'none'}}}
            muiTableBodyCellProps={{ sx: { border: 'none', color: text.main, align: 'center', boxShadow: 'none', } }}
            muiTableProps={{ sx: { backgroundColor: primary.main, color: text.main, boxShadow: 'none' } }}
            // muiTableToolbarTopProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none', minHeight: 0} }}
            // muiTableToolbarBottomProps={{ sx: {backgroundColor: primary.main, boxShadow: 'none'} }}
            muiTopToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none', minHeight: 0 } }}
            muiBottomToolbarProps={{ sx: { backgroundColor: primary.main, boxShadow: 'none' } }}
            muiTableHeadRowProps={{ sx: { backgroundColor: primary.main, color: text.main, textAlign: 'center' }, }}
            muiTableHeadCellProps={{ sx: { borderBottom: 0, verticalAlign: 'none', boxShadow: 'none', align: 'center', color: text.main } }}
            enableColumnActions={false}
            initialState={{ density: 'compact', }}
            enablePagination={true}
            positionPagination="bottom"
            muiTablePaginationProps={{
                rowsPerPageOptions: [5, 10, 15, 20],
                sx: { color: text.main, '& p': { marginBottom: 0 }, '& .MuiSvgIcon-root': { color: text.main, }, }
            }}
        />
    );
}

export default LicenseHistory_table;